export const ACCESS_NOTICE_TITLE = {
  english: "File Access Notice",
  chinese: "文件访问提示",
};

export const ACCESS_NOTICE_BUTTON_LABEL = "OK (确定)";

const VIEWER_NOTICES = {
  "other-tabs-active": {
    kind: "other-tab-viewing",
    english: "This annotation sheet is still open in another tab. Close the other tab and try again.",
    chinese: "此标注表仍在其他页面中打开。请关闭其他页面后重试。",
  },
  "other-annotators-viewing": {
    kind: "other-annotator-viewing",
    english: "Another annotator is currently viewing this annotation sheet, so you cannot switch to Editing.",
    chinese: "他人正在查看此标注表，暂时无法切换到编辑模式。",
  },
  "other-tabs-and-annotators-viewing": {
    kind: "other-tab-and-annotator-viewing",
    english: "This annotation sheet is open in another tab and is also being viewed by another annotator, so you cannot switch to Editing.",
    chinese: "此标注表仍在其他页面中打开，同时也有他人正在查看，暂时无法切换到编辑模式。",
  },
};

const FATAL_CONFLICT_NOTICES = {
  "editor-active": {
    kind: "other-annotator-editing",
    english: "This file is currently being edited by another annotator.",
    chinese: "他人正在编辑此文件。",
  },
  "editor-active-own-tab": {
    kind: "other-tab-editing",
    english: "This file is currently being edited in another tab.",
    chinese: "此文件正在其他页面中编辑。",
  },
  "session-not-active": {
    kind: "access-expired",
    english: "Your access to this file expired. Reopen the file to continue.",
    chinese: "当前页面的访问权限已失效，请重新打开文件。",
  },
};

const NETWORK_NOTICE = {
  kind: "network",
  english: "Could not connect to server.",
  chinese: "无法连接服务器。",
  exitOnDismiss: true,
};

export function createAnnotationSheetAccessNotice({ error, action }) {
  const reason = error?.payload?.reason;
  const viewerNotice = VIEWER_NOTICES[reason];
  if (viewerNotice) {
    return {
      ...viewerNotice,
      exitOnDismiss: action !== "upgrade",
    };
  }

  const fatalConflictNotice = FATAL_CONFLICT_NOTICES[reason];
  if (fatalConflictNotice) {
    return { ...fatalConflictNotice, exitOnDismiss: true };
  }

  return { ...NETWORK_NOTICE };
}
